import { useEffect, useState, useContext, useRef } from "react";
import { useParams } from "react-router";
import { Link } from 'react-router-dom';

import { cookie } from 'shared-kernel/helpers';

import { LayoutContext } from "../layout/";
import { getEndpoint } from "../helper";

import Loader from "../loader";

import { addProduct, save, getTotalQuantity } from './storage';

export default function CategoryProduct({ brandId }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [levelOne, setLevelOne] = useState([]);
    const [levelOneActiveId, setLevelOneActiveId] = useState(0);
    const [levelTwo, setLevelTwo] = useState([]);
    const [levelTwoActiveId, setLevelTwoActiveId] = useState(0);
    const [products, setProducts] = useState([]);
    const [openedLevelTwoIds, setOpenedLevelTwoIds] = useState([]);

    const { setPaperCount, setCartCount } = useContext(LayoutContext);

    const { categoryId } = useParams();
    const scrollY = useRef(0);

    const formatNumber = n => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const getProductEndpoint = (id) => {
        return getEndpoint(brandId ? `/api/android/product/getlist?categoryId=${id}&brandId=${brandId}` : `/api/android/product/getlist?categoryId=${id}`);
    };

    const handleLevelOneClick = (id) => {
        setLevelOneActiveId(id);

        const levelTwo = data.filter(x => x.parentId == id);
        setLevelTwo(levelTwo);

        setProducts([]);

        levelTwo.length == 0 && loadProducts(id);
    }

    const loadProducts = (id) => {
        fetch(getProductEndpoint(id))
            .then(res => res.json())
            .then(data => {
                setProducts(data.data);
                setLevelTwo([]);
                setLoading(false);
            });
    }

    const handleLevelTwoClick = (id, hasLevel3) => {
        if (hasLevel3) {
            setProducts([]);
            setOpenedLevelTwoIds(prev =>
                prev.includes(id)
                    ? prev.filter(item => item !== id)
                    : [...prev, id]
            );
        }
        else {
            setLoading(true);

            loadProducts(id);
        }
    }

    const handleLevelThreeClick = (id) => {
        setLoading(true);
        setOpenedLevelTwoIds([]);

        loadProducts(id);
    }

    const LevelTwoBox = ({ id, picture, title }) => {
        const Img = () => (
            <div className='mr-a' style={{ width: '7.4rem' }}>
                {
                    (picture && picture.length > 0)
                        ? <img src={getEndpoint(`/uploads/shop/category/${picture}`)} />
                        : <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />
                }
            </div>
        );

        const l3 = data.filter(x => x.parentId == id);

        return (
            <div>
                <div
                    className='d-f br-2 bbw-2 my-2 ml-2 p-2 p-r us-n'
                    style={{ backgroundColor: '#e1e1e1', borderBottomColor: '#d7d7d7' }}
                    onClick={e => handleLevelTwoClick(id, l3.length > 0)}
                >
                    {title}
                    <Img />

                    {l3.length > 0 && (
                        <svg className='p-a l-50 b-0' xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
                            <path d={openedLevelTwoIds.indexOf(id) > -1 ? 'M9.875 19.031l-1.875-1.875 8-8 8 8-1.875 1.875-6.125-6.125z' : 'M9.875 9.906l6.125 6.125 6.125-6.125 1.875 1.875-8 8-8-8z'} />
                        </svg>
                    )}
                </div>
                {
                    openedLevelTwoIds.indexOf(id) > -1 && l3.length > 0 && l3.map(x => <LevelThreeBox key={x.id} id={x.id} title={x.title} picture={x.picture} />)
                }
            </div>
        );
    }

    const LevelThreeBox = ({ id, picture, title }) => {
        const Img = () => (
            <div className='mr-a' style={{ width: '7.4rem' }}>
                {
                    (picture && picture.length > 0)
                        ? <img src={getEndpoint(`/uploads/shop/category/${picture}`)} />
                        : <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />
                }
            </div>
        );

        return (
            <div
                className='br-2 bbw-2 my-3 ml-4 mr-2 p-2 p-r us-n bc-w'
                style={{ borderBottomColor: '#d7d7d7' }}
                onClick={e => handleLevelThreeClick(id)}
            >
                {title}
                <Img />
            </div>
        );
    }

    const handleAddToList = (id, title, picture) => {
        addProduct(id, title, picture);
        setPaperCount(getTotalQuantity());
    }

    const ProductBox = ({ id, title, picture }) => (
        <div className='d-f ai-fe br-2 bc-w bbw-2 my-2 ml-2 p-2 bsh-1' style={{ borderBottomColor: '#d7d7d7' }}>
            <div className='mb-6'>
                {title}
            </div>
            <div className='p-1 br-2 mr-a' style={{ backgroundColor: '#ff8500' }} onClick={e => handleAddToList(id, title, picture)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
                    <path fill="white" d="M4 27.781v-26.625l2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2v26.625l-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2-2 2-2-2zM24 10.469v-2.688h-16v2.688h16zM24 15.781v-2.625h-16v2.625h16zM24 21.156v-2.688h-16v2.688h16z"></path>
                </svg>
            </div>
        </div >
    );

    const addToCart = (productId) => {
        fetch(getEndpoint('/api/cart/submit'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: undefined,
                cartId: cookie.get('cid'),
                productId,
                brandId,
                customProductId: null,
                quantity: 1
            })
        })
            .then(res => res.json())
            .then(data => {
                cookie.set('cid', data.data);

                fetch(getEndpoint(`/api/cart/get?cartid=${data.data}`))
                    .then(res => res.json())
                    .then(data => {
                        let quantitySum = data.data.reduce((p, c) => p += c.quantity, 0);

                        setCartCount(quantitySum);
                    });
            })
            .catch(err => console.error(err));
    }

    const ProductBox2 = ({ id, picture, title, price, oldPrice, discount, status, status_ }) => {
        return (
            <div className='bsh-4 bc-w my-2 ml-2 br-4 o-h'>
                <div className='mt-1 mr-2'>
                    {title}
                </div>

                <div className='d-f ai-c px-2'>
                    {status == 10 &&
                        (<>
                            <div className='d-f ai-c jc-c _bc-g-d c-w p-1 br-4'>
                                <div className='d-l fs-4'>{discount}%</div>
                            </div>
                            <div className='mr-2 fw-600'>
                                <div className='d-f ai-c mt-1'>
                                    <div className='fs-3' style={{ color: '#9c9c9c', textDecorationLine: 'line-through' }}>{formatNumber(oldPrice)}</div>
                                    &nbsp;
                                    <div style={{ color: '#9c9c9c', fontSize: '.8em' }}>ریال</div>
                                </div>
                                <div className='d-f ai-c p-r _c-b_b' style={{ top: '-.5em' }}>
                                    <div className='fs-3'>{formatNumber(price)}</div>
                                    &nbsp;
                                    <div style={{ fontSize: '.8em' }}>ریال</div></div>
                            </div>
                            <div className='_bc-o d-if mr-a p-1 br-3' style={{ padding: '.6rem' }} onClick={e => addToCart(id)}>
                                <img style={{ width: '1.7rem' }} src={getEndpoint("/pwa/img/icons/add2basket.svg")} />
                            </div>
                        </>)
                    }
                    {status != 10 && (
                        <div className='d-f ai-fe fw-600' style={{ color: '#FC0000', height: '5.5rem', fontSize: '1.3em', paddingBottom: '.8rem' }} children={status_} />
                    )}
                </div>
            </div>
        );
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(brandId ? `/api/android/category/GetAllChildren?parentId=${categoryId}&brandId=${brandId}` : `/api/android/category/GetAllChildren?parentId=${categoryId}`), { signal });
                const json = await response.json();
                setData(json.data);

                const levelOne = json.data.filter(x => x.parentId == categoryId);
                setLevelOne(levelOne);
                setLevelOneActiveId(levelOne[0].id);                                

                const levelTwo = json.data.filter(x => x.parentId == levelOne[0].id);
                setLevelTwo(levelTwo);

                levelTwo.length === 0 && loadProducts(levelOne[0].id);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        setPaperCount(getTotalQuantity());

        return () => controller.abort();
    }, [categoryId]);

    useEffect(() => {
        if (loading) return;

        const onScroll = () => {
            scrollY.current = window.scrollY;
        };

        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [loading]);

    useEffect(() => {
        if (loading) return;

        if (scrollY.current > 0) {
            window.scrollTo(0, scrollY.current);
        }
    }, [loading]);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='d-f fw-w jc-sb' style={{ backgroundColor: '#f5f5f5' }}>
            <div className='o-a fsh-0 fg-0' style={{ width: '12.6rem', height: 'calc(100vh - 5.8rem)' }}>
                {levelOne.map(x => (
                    <div className={`level-1 p-3 bbw-1 bbc-w us-n ${x.id == levelOneActiveId ? 'active' : ''}`} key={x.id} onClick={e => handleLevelOneClick(x.id)}>
                        {x.title}
                    </div>
                ))}
            </div>
            <div className='o-a' style={{ width: 'calc(100% - 13.6rem)', height: 'calc(100vh - 5.8rem)' }}>
                {
                    levelTwo.length > 0 && levelTwo.map(x => <LevelTwoBox key={x.id} id={x.id} title={x.title} picture={x.picture} />)
                }
                {
                    products.length > 0 && products.map(x => (
                        brandId
                            ? <ProductBox2
                                key={x.id}
                                id={x.id}
                                title={x.title}
                                picture={x.picture}
                                price={x.price}
                                oldPrice={x.oldPrice}
                                discount={x.discount}
                                status={x.status}
                                status_={x.status_}
                            />
                            : <ProductBox key={x.id} id={x.id} title={x.title} picture={x.picture} />
                    ))
                }
            </div>
        </div>
    );
}